import api from "./apiClient";

const API_URL = process.env.VUE_APP_API_BASE_URL + '/api/v2/';

export default {
  async analyticsParticipantes(payload) {
    const response = await api.post(API_URL + "analytics/participantes", payload ?? {});
    return response.data;
  },

  async analyticsParticipantesExport(payload) {
    const response = await api.post(API_URL + "analytics/participantes/export", payload ?? {}, {
      responseType: "blob",
    });
    return response;
  },

  async analyticsParticipantesDetalle(payload) {
    const response = await api.post(API_URL + "analytics/participantes/detalle", payload ?? {});
    return response.data;
  },

  async analyticsActualizarNicks(payload) {
    const response = await api.post(API_URL + "analytics/participantes/actualizar-nicks", payload ?? {});
    return response.data;
  },

  async analyticsParticipantesPorUsuario(payload) {
    const response = await api.post(API_URL + "analytics/participantes/por-usuario", payload ?? {});
    return response.data;
  },

  async analyticsParticipantesPorUsuarioExport(payload) {
    const response = await api.post(API_URL + "analytics/participantes/por-usuario/export", payload ?? {}, {
      responseType: "blob",
    });
    return response;
  },

  async analyticsVentas(payload) {
    const response = await api.post(API_URL + "analytics/ventas", payload ?? {});
    return response.data;
  },

  async analyticsVentasDetalle(payload) {
    const response = await api.post(API_URL + "analytics/ventas/detalle", payload ?? {});
    return response.data;
  },

  async analyticsVentasDetalleProducto(payload) {
    const response = await api.post(API_URL + "analytics/ventas/detalle-producto", payload ?? {});
    return response.data;
  },
};
